/**
 * @param {object} rowData
 * @param {string} poType
 * @returns {{ sku: string | number, itemName: string, unitsPerCase: number | null }}
 */
function getLineItemDisplayFields(rowData, poType) {
    const original = rowData?.original ?? {};

    if (poType === 'PACKAGING') {
        const unitsPerCase = original.receivedUnitsPerCase ?? original.unitsPerCase ?? null;
        return {
            sku: original.masterSku,
            itemName: original.description ?? '',
            unitsPerCase: unitsPerCase != null ? Number(unitsPerCase) : null,
        };
    }

    const unitsPerCase = original.receivedUnitCount ?? original.baseUnitsPerCase ?? null;
    return {
        sku: original.itemMasterSKU,
        itemName: original.itemMasterName ?? '',
        unitsPerCase: unitsPerCase != null ? Number(unitsPerCase) : null,
    };
}

/**
 * @param {{ totalCases: number, numPallets: number, unitsPerCase?: number | null }} params
 * @returns {string}
 */
function formatReceivedSummary({ numPallets, totalCases, unitsPerCase }) {
    const segments = [
        `Total received: ${totalCases} ${totalCases === 1 ? 'case' : 'cases'}`,
        `${numPallets} ${numPallets === 1 ? 'pallet' : 'pallets'}`,
    ];

    if (unitsPerCase != null && !Number.isNaN(unitsPerCase)) {
        segments.push(`${unitsPerCase} units/case`);
    }

    return segments.join(' · ');
}

export { formatReceivedSummary, getLineItemDisplayFields };
